import script from "./SearchPageSearchResultsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchResultsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchResultsHeader.vue?vue&type=style&index=0&id=016b37fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016b37fe"]])

export default __exports__